export default "__VITE_ASSET__B9_I47Gb__"